import AboutMe from './pages/AboutMe';
import AboutProject from './pages/AboutProject';
import ScrollToTop from "react-scroll-to-top";
import aiStudioBanner from './images/ai_banner5.png';
import foodSafetyBanner from './images/foodsafety_banner2c.jpg';
import activityBanner from './images/activity_banner2c.jpg';
import designManagementBanner from './images/design_mgmt_banner.png';
import dashboardsBanner from './images/appbuilder_thumb3.png';
import riceAiBanner from './images/mgg-vitchakorn-zXNC_lBBVGE-unsplashCROPcc.jpg';
import Footer from './toolbar/Footer';
import PageTransition from './pageTransition';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { staggerContainer, fadeUp } from './motionVariants';
import GrainOverlay from './GrainOverlay';

function DesignPhilosophy() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-80px" });

    const pillars = [
        {
            title: "Clarity from Complexity",
            text: "I turn intricate domains — AI, fintech, industrial IoT — into interfaces that feel simple and inevitable.",
        },
        {
            title: "Design as Strategy",
            text: "Design isn't just pixels. It's aligning business goals, user needs, and engineering constraints into a coherent vision.",
        },
        {
            title: "Teams that Ship",
            text: "I build design cultures where teams operate with autonomy, craft, and velocity — not just process.",
        },
    ];

    return (
        <section className="philosophy grain-light" ref={ref}>
            <GrainOverlay intensity={0.06} />
            <motion.div
                className="philosophy-inner"
                variants={staggerContainer(0.15, 0.2)}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
            >
                <motion.p className="philosophy-label" variants={fadeUp}>
                    HOW I WORK
                </motion.p>
                <motion.h2 className="philosophy-heading" variants={fadeUp}>
                    Design Philosophy
                </motion.h2>
                <div className="philosophy-grid">
                    {pillars.map((p, i) => (
                        <motion.div className="philosophy-card" key={i} variants={fadeUp}>
                            <h3>{p.title}</h3>
                            <p>{p.text}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </section>
    );
}

function MetricsBar() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-60px" });

    const metrics = [
        { value: "12+", label: "Years in Design Leadership" },
        { value: "17+", label: "Enterprise Clients" },
        { value: "5+", label: "Industries" },
    ];

    return (
        <motion.section
            className="metrics-bar"
            ref={ref}
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
            {metrics.map((m, i) => (
                <div className="metric" key={i}>
                    <span className="metric-value">{m.value}</span>
                    <span className="metric-label">{m.label}</span>
                </div>
            ))}
        </motion.section>
    );
}


function Home() {
    const scrollToWork = () => {
        const hero = document.querySelector('.AboutMe');
        if (hero) {
            window.scrollTo({
                top: hero.offsetHeight,
                behavior: 'smooth',
            });
        }
    };

    return (
        <>
        <PageTransition>
            <div className="App">
                <AboutMe scrollToWork={scrollToWork} />
            </div>

            <DesignPhilosophy />
            <MetricsBar />

            <AboutProject
                title="Design Management"
                description="Building design culture, operations, and team strategy from the ground up"
                redirectUrl="mgmt"
                imageUrl={designManagementBanner}
                odd={true}
            />
            <AboutProject
                title="AI Studio"
                description="Led design strategy for an enterprise AI platform, from concept workshops to shipped product"
                redirectUrl="aistudio"
                imageUrl={aiStudioBanner}
                odd={false}
            />
            <AboutProject
                title="App Builder"
                description="Single-handedly designed the platform's core tool, adopted company-wide across every department"
                redirectUrl="appbuilder"
                imageUrl={dashboardsBanner}
                odd={true}
            />
            <AboutProject
                title="Activity Tracking"
                description="Owned the full product lifecycle — from writing the MRD and defining personas to shipping an analytics system"
                redirectUrl="activity"
                imageUrl={activityBanner}
                odd={false}
            />
            <AboutProject
                title="Food Safety"
                description="Led end-to-end design for an AI-powered food safety platform, from factory floor research to shipped product"
                redirectUrl="foodsafety"
                imageUrl={foodSafetyBanner}
                odd={true}
            />
            <AboutProject
                title="Rice AI"
                description="Led product design from factory floor research to an insight dashboard that quantified industrial waste in dollars"
                redirectUrl="riceai"
                imageUrl={riceAiBanner}
                odd={false}
            />

            <Footer />
        </PageTransition>
        <ScrollToTop smooth className="scroll-to-top" />
        </>
    );
}

export default Home;
